import type { Register } from './register'
import { useState, useEffect, Suspense } from 'react'
import { HashRouter, Routes, Route, Navigate, useLocation, matchPath } from 'react-router-dom'
import { appStore } from 'src/stores'
import register from './register'
import 'src/utils/predayjs'
import 'src/styles/index.less'

const RouteElement = (props: { route: any }) => {
  const location = useLocation()

  const matchExact = matchPath({
    path: props.route.path
  }, location.pathname)

  const { redirect, component: RouteComponent } = props.route
  return (
    <Suspense fallback={<div />}>
      {matchExact && redirect ? <Navigate replace to={redirect} /> : null}
      <RouteComponent />
    </Suspense>
  )
}

const Main = (props: { micro?: any }) => {
  // 挂载主应用传递给微应用的数据
  useEffect(() => {
    appStore.mount(props.micro)
  }, [props.micro])

  // 全局错误处理
  useEffect(() => {
    const globalRejection = (evt: PromiseRejectionEvent) => {
      // 生产环境则不将错误输出到控制台
      process.env.NODE_ENV !== 'development' && evt.preventDefault()
    }

    window.addEventListener('unhandledrejection', globalRejection)

    return () => {
      window.removeEventListener('unhandledrejection', globalRejection)
    }
  }, [])

  const [routes, setRoutes] = useState<any[]>([])
  useEffect(() => {
    let registerData: Register

    register()
      .then(data => { registerData = data })
      // 挂载各个子应用的 willMount 生命周期函数
      .then(() => {
        return registerData.beforeMounted?.()
      })
      // 最后设置路由页面显示
      .then(() => {
        setRoutes(registerData.routes)
      })

    return () => {
      /**
       * 使用 Promise 推入微任务，
       * 是因为 useEffect 卸载的时候，父组件先卸载，然后子组件才卸载，
       * 这边需要保证所有子组件先卸载，再调用 willUnmount 生命周期函数，
       * 所以这边用 Promise
       */
      Promise.resolve().then(() => {
        // 子模块卸载后调用的方法
        registerData?.afterUnmounted?.()
      })
    }
  }, [])

  const generateRoutes = (routes: any[]) => {
    return routes.map((route: any, index: number) => {
      const { path, children } = route
      return (
        <Route
          key={`${path}-${index}`}
          path={path}
          element={<RouteElement route={route} />}
        >
          {Array.isArray(children) && children.length ? generateRoutes(children) : null}
        </Route>
      )
    })
  }

  if (!routes.length) return null

  return (
    <HashRouter basename={window.__DEFINED_BASENAME_BY_QIANKUN__ || '/'}>
      <Routes>{generateRoutes(routes)}</Routes>
    </HashRouter>
  )
}

export default Main